import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Typography from 'components/global/Typography';

const StringArray = ({ value, column: { translate } }) => {
	const { t } = useTranslation();

	const safeParsedValue = useMemo(() => {
		try {
			const data = JSON.parse(value);
			if (Array.isArray(data)) {
				if (translate) {
					return data.map((item) => t(item))?.join?.(', ');
				} else {
					return data.join?.(', ');
				}
			}
			throw new Error();
		} catch {
			if (translate) {
				return t(value);
			} else {
				return value;
			}
		}
	}, [t, value]);

	return <Typography>{safeParsedValue}</Typography>;
};

export default StringArray;
